<template lang="pug">
  #business-list
    .table-view
      .table-view-header
        .table-view-header-title
          h3 Empresas
        .table-view-header-actions
          b-button(@click="onUpdateAll(false)" style="min-width: 150px" variant="outline-primary") Desactivar todo
          b-button(@click="onUpdateAll(true)" style="min-width: 150px") Activar todo
      b-table(:items="tableItems" :fields="fields" responsive)
        template(v-slot:cell(name)="{item}")
          router-link(:to="{ name:'BusinessDetail', params:{ id: item.bussinesId } }") {{item.name}}
        template(v-slot:cell(rut)="{value}")
          div(style="min-width: 130px;") {{value}}
        template(v-slot:cell(startDate)="{item, value}")
          div(style="min-width: 100px; max-width: 150px;")
            BaseInputConfirmChange(
              v-model="item.form.startDate"
              @change="onSave(item.form)"
              type="date" :disabled="item.form.id ? false : true"
              size="sm"
            )
        template(v-slot:cell(active)="{item}")
          .table-actions
            b-form-checkbox(v-model="item.form.active" switch @change="onSave(item.form)")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import BaseInputConfirmChange from '../common/BaseInputConfirmChange.vue'

export default {
  components: {
    BaseInputConfirmChange
  },
  data() {
    return {
      fields: [
        {
          label: 'Nombre',
          key: 'name',
          sortable: true
        },
        {
          label: 'RUT',
          key: 'rut',
          sortable: true
        },
        {
          label: 'Fecha Inicio',
          key: 'startDate',
          sortable: true
        },
        {
          label: 'Activo',
          key: 'active',
          sortable: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['businesses', 'businessServices', 'service']),
    tableItems () {
      return this.businesses.map((b) => {
        const businessService = this.businessServices.find(bs => bs.businessId === b.id)
        return {
          bussinesId: b.id,
          name: b.name,
          rut: b.rut,
          startDate: businessService ? businessService.startDate : '-',
          active: businessService ? businessService.active : false,
          form: { 
            active: businessService ? businessService.active : false,
            businessId: b.id,
            id: businessService ? businessService.id : undefined,
            serviceId: this.service.id,
            startDate: businessService ? this.$options.filters.dateFormat(new Date(businessService.startDate), 'YYYY-MM-DD') : this.$options.filters.dateFormat(new Date(), 'YYYY-MM-DD')
          }
        }
      })
    },
  },
  methods: {
    ...mapActions(['listBusiness', 'listBusinessServices', 'editBusinessService', 'createBusinessService', 'allUpdateBusinessServices']),
    async onSave (data) {
      if (data.id) {
        await this.editBusinessService(data)
      } else {
        await this.createBusinessService(data)
      }
      this.fetchData()
    },
    async onUpdateAll (active) {
      const data = {
        startDate: "2021-01-01",
        active
      }
      await this.allUpdateBusinessServices({ serviceId: this.$route.params.id, data })
      this.fetchData()
    },
    fetchData () {
      this.listBusinessServices({ serviceId: this.$route.params.id })
    }
  },
  created() {
    this.fetchData()
    this.listBusiness()
  }
}
</script>
